"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyPremadeFlashcardType = exports.AnyPremadeFlashcardTypeSchema = exports.AnyNonMinimalPairFlashcardTypeSchema = exports.WordStressFlashcardTypeSchema = exports.ToneFlashcardTypeSchema = exports.StrokeOrderFlashcardTypeSchema = exports.SpellingFlashcardTypeSchema = exports.PronounceFlashcardTypeSchema = exports.MissingLetterFlashcardTypeSchema = exports.MinimalPairFlashcardTypeSchema = exports.AlphabetFlashcardTypeSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
exports.AlphabetFlashcardTypeSchema = zod_1.z.literal("ALPHABET");
exports.MinimalPairFlashcardTypeSchema = zod_1.z.literal("MINIMAL_PAIR");
exports.MissingLetterFlashcardTypeSchema = zod_1.z.literal("MISSING_LETTER");
exports.PronounceFlashcardTypeSchema = zod_1.z.literal("PRONOUNCE");
exports.SpellingFlashcardTypeSchema = zod_1.z.literal("SPELLING");
exports.StrokeOrderFlashcardTypeSchema = zod_1.z.literal("STROKE_ORDER");
exports.ToneFlashcardTypeSchema = zod_1.z.literal("TONE");
exports.WordStressFlashcardTypeSchema = zod_1.z.literal("WORD_STRESS");
exports.AnyNonMinimalPairFlashcardTypeSchema = zod_1.z.union([
    exports.AlphabetFlashcardTypeSchema,
    exports.MissingLetterFlashcardTypeSchema,
    exports.PronounceFlashcardTypeSchema,
    exports.SpellingFlashcardTypeSchema,
    exports.StrokeOrderFlashcardTypeSchema,
    exports.ToneFlashcardTypeSchema,
    exports.WordStressFlashcardTypeSchema,
]);
exports.AnyPremadeFlashcardTypeSchema = zod_1.z.union([
    exports.AnyNonMinimalPairFlashcardTypeSchema,
    exports.MinimalPairFlashcardTypeSchema,
]);
exports.isAnyPremadeFlashcardType = type_validation_helpers_1.getTypeValidationFunction(exports.AnyPremadeFlashcardTypeSchema);
//# sourceMappingURL=premade_flashcard_type_types.js.map